import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withNamespaces } from 'react-i18next'
import ReactCountryFlag from 'react-country-flag'
import {
  Container,
  DropdownToggle,
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown
} from 'reactstrap'

import { authLogout } from '../actions/auth'
import DropdownLanguage from '../components/DropdownLanguage'

class AppRentalHeader extends React.Component {
  getCountryCode(lang) {
    switch (lang) {
      case 'es': return 'ES'
      case 'en': return 'GB'
      case 'it': return 'IT'
      case 'de': return 'DE'
      case 'fr': return 'FR'
      case 'pt': return 'PT'
      default:   return 'GB'
    }
  }

  getLanguageCode(lang) {
    switch (lang) {
      case 'es': return 'ES'
      case 'en': return 'EN'
      case 'it': return 'IT'
      case 'de': return 'DE'
      case 'fr': return 'FR'
      case 'pt': return 'PT'
      default:   return 'EN'
    }
  }

  getLogoSrc() {
    const { qrData } = this.props
    if (qrData?.headerConfig?.logoBase64) {
      return qrData.headerConfig.logoBase64
    }
    return '/images/logo.png'
  }

  getHeaderStyle() {
    const { qrData } = this.props
    if (qrData?.headerConfig?.primaryColor && qrData?.headerConfig?.secondaryColor) {
      return {
        background: `linear-gradient(90deg, ${qrData.headerConfig.primaryColor} 0%, ${qrData.headerConfig.secondaryColor} 100%)`
      }
    }
    return {
      background: 'linear-gradient(45deg, #01315f, #067ddb)'
    }
  }

  render() {
    const { i18n } = this.props

    return (
      <Navbar className="rm-header box-shadow" dark expand="md" style={this.getHeaderStyle()}>
        <Container className="nm-header-container">
          <NavbarBrand>
            <img className="logo" src={this.getLogoSrc()} alt="Logo" />
          </NavbarBrand>
          <Nav className="ml-auto" navbar>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav tag="div" className="time-lang-toggle">
                <span className="time-lang-card">
                  <ReactCountryFlag
                    countryCode={this.getCountryCode(i18n.language)}
                    svg
                    style={{ width: '1.3em', height: '1.3em', borderRadius: '3px' }}
                  />
                  <span className="time-lang-code">{this.getLanguageCode(i18n.language)}</span>
                  <i className="fas fa-chevron-down time-lang-caret"></i>
                </span>
              </DropdownToggle>
              <DropdownLanguage />
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    )
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  authLogout: bindActionCreators(authLogout, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(AppRentalHeader))
